import script from "./MenuLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLeft.vue?vue&type=script&setup=true&lang=js"

import "./MenuLeft.vue?vue&type=style&index=0&id=6e449916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e449916"]])

export default __exports__